import * as apiService from "../api-service";

// Booker, FindSomeoneSpotlight, the Employees page itself, and several Business-module reports
// all independently call apiService.getEmployees for the same company within moments of each
// other (e.g. loading Booker also loads FindSomeoneSpotlight's own copy on the very same page
// load). This cache means only the first caller in any given window actually hits the network -
// every other caller reuses that same in-flight/recently-resolved promise instead of re-fetching
// identical data. 15s matches the backend's own all-users cache TTL (get-employees.js) - no point
// this cache outliving the data it could actually get a fresher copy of.
const CACHE_TTL_MS = 15_000;
const cache = new Map(); // companyId -> { expiresAt, promise }

export function getEmployeesCached({ userIdToken, companyId }) {
  const now = Date.now();
  const cached = cache.get(companyId);
  if (cached && cached.expiresAt > now) {
    return cached.promise;
  }

  const promise = apiService.getEmployees({ userIdToken, companyId }).catch((err) => {
    // Don't leave a rejected promise cached for the rest of the TTL - the next caller gets a
    // fresh attempt instead of the same failure replayed at them.
    if (cache.get(companyId)?.promise === promise) cache.delete(companyId);
    throw err;
  });

  cache.set(companyId, { expiresAt: now + CACHE_TTL_MS, promise });
  return promise;
}

// Called after any mutation that changes the employee list (role/extra-roles updates, create,
// delete) so the very next read - typically that same page's own reload - gets genuinely fresh
// data instead of a stale cached copy.
export function invalidateEmployeesCache(companyId) {
  cache.delete(companyId);
}
